(function () {
  'use strict';
  var launcher = document.getElementById('gtj-chat-launcher');
  if (!launcher) return;
  var button = launcher.querySelector('a');
  var status = launcher.querySelector('[role="status"]');
  var loading = false;
  var ready = false;
  var requested = false;
  var failed = false;
  var timeout;
  var sessionKey = 'gtj-chat-used';

  function showFailure() {
    if (ready) return;
    failed = true;
    button.removeAttribute('aria-busy');
    button.removeAttribute('role');
    status.textContent = launcher.dataset.error;
    launcher.dataset.state = 'error';
  }

  function finish() {
    if (!window.PodiumWebChat || typeof window.PodiumWebChat.open !== 'function') return;
    ready = true;
    failed = false;
    clearTimeout(timeout);
    button.removeAttribute('aria-busy');
    status.textContent = '';
    launcher.hidden = true;
    document.dispatchEvent(new CustomEvent('gtj:chat-ready'));
    if (requested) {
      requested = false;
      try { sessionStorage.setItem(sessionKey, '1'); } catch (error) { /* Storage is optional. */ }
      window.PodiumWebChat.open();
    }
  }

  function load() {
    if (loading || ready) return;
    loading = true;
    window.PodiumWebChat = window.PodiumWebChat || {};
    var previousLoad = window.PodiumWebChat.onLoad;
    window.PodiumWebChat.onLoad = function (configuration) {
      try {
        if (typeof previousLoad === 'function') previousLoad(configuration);
      } finally {
        window.requestAnimationFrame(finish);
      }
    };
    var script = document.createElement('script');
    script.id = 'podium-widget';
    script.src = 'https://connect.podium.com/widget.js#ORG_TOKEN=' + launcher.dataset.token;
    script.setAttribute('data-organization-api-token', launcher.dataset.token);
    script.async = true;
    script.onerror = showFailure;
    timeout = window.setTimeout(showFailure, 20000);
    document.body.appendChild(script);
  }

  button.setAttribute('role', 'button');
  button.addEventListener('click', function (event) {
    if (failed) return;
    event.preventDefault();
    if (requested) return;
    requested = true;
    button.setAttribute('aria-busy', 'true');
    launcher.dataset.state = 'loading';
    status.textContent = launcher.dataset.loading;
    load();
  });
  button.addEventListener('keydown', function (event) {
    if (event.key === ' ' && !failed) {
      event.preventDefault();
      button.click();
    }
  });
  var used = false;
  try { used = sessionStorage.getItem(sessionKey) === '1'; } catch (error) { /* Storage is optional. */ }
  if (used) load();
}());
